import { render, staticRenderFns } from "./ChildDropdown.vue?vue&type=template&id=52deedf4&scoped=true&"
import script from "./ChildDropdown.vue?vue&type=script&lang=ts&"
export * from "./ChildDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./ChildDropdown.vue?vue&type=style&index=0&id=52deedf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52deedf4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListItemContent,VListItemSubtitle,VListItemTitle})
